import React, { useState } from "react";
import {
  Button,
  Typography,
  Box,
  TextField,
  InputAdornment,
  IconButton,
  FormControl,
  InputLabel,
  OutlinedInput,
  FormHelperText,
} from "@mui/material";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import { resetPassword } from "../../../../../services/Manage_service";
import { useAppDispatch } from "../../../../../services/StoreHooks";

function ResetPasswordModal(props) {
  const { id, setModalOpen } = props;
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((show) => !show);
  let msg = "";
  const passwordChangeHandler = (e) => {
    setPassword(e.target.value);

    if (e.target.value.trim().length === 0) {
      document.getElementById("password-validate-message").innerHTML =
        "Password can not be Empty";
      document.getElementById("password-validate-message").style.color = "red";
    } else if (e.target.value.length < 8) {
      document.getElementById("password-validate-message").innerHTML =
        "Password must have atleast 8 characters";
      document.getElementById("password-validate-message").style.color = "red";
    } else if (confirmPassword && e.target.value !== confirmPassword) {
      document.getElementById("confirm-password-validate-message").innerHTML =
        "Passwords do not match";
      document.getElementById("confirm-password-validate-message").style.color =
        "red";
    } else {
      document.getElementById("password-validate-message").innerHTML = "";
    }
  };

  const confirmPasswordChangeHandler = (e) => {
    setConfirmPassword(e.target.value);
    if (e.target.value.trim().length === 0) {
      document.getElementById("confirm-password-validate-message").innerHTML =
        "Password can not be Empty";
      document.getElementById("confirm-password-validate-message").style.color =
        "red";
    } else if (e.target.value !== password) {
      document.getElementById("confirm-password-validate-message").innerHTML =
        "Passwords do not match";
      document.getElementById("confirm-password-validate-message").style.color =
        "red";
    } else {
      document.getElementById("confirm-password-validate-message").innerHTML =
        "";
    }
  };

  const dispatch = useAppDispatch();
  const dispatchNotification = (typ, msg) => {
    dispatch({
      type: "SHOW_NOTIFICATION",
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const handlePasswordReset = async () => {

    const apiBody = {
      userId : parseInt(id),
      password : password
    }

    const result = await resetPassword(id, apiBody);
    if (result.status === 200) {
      setModalOpen(false);
      dispatchNotification("success", [result.data]);
    }
  };

  return (
    <Box sx={{ textAlign: "center" }}>
      <Typography sx={{ margin: 1 }} variant="h6">
        Reset Password
      </Typography>

      <FormControl variant="outlined" sx={{ width: "80%", my: 1 }}>
        <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
        <OutlinedInput
          id="outlined-adornment-password"
          type={showPassword ? "text" : "password"}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
          required
          label="Password"
          value={password}
          onChange={(e) => {
            passwordChangeHandler(e);
          }}
        />
        <FormHelperText id="password-validate-message">{msg}</FormHelperText>
      </FormControl>

      <FormControl variant="outlined" sx={{ width: "80%", my: 1 }}>
        <InputLabel htmlFor="outlined-adornment-password">
          Confirm Password
        </InputLabel>
        <OutlinedInput
          id="outlined-adornment-password"
          type={showConfirmPassword ? "text" : "password"}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowConfirmPassword}
                edge="end"
              >
                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
          label="Confirm Password"
          required
          value={confirmPassword}
          onChange={(e) => {
            confirmPasswordChangeHandler(e);
          }}
        />
        <FormHelperText id="confirm-password-validate-message">
          {msg}
        </FormHelperText>
      </FormControl>
      <Button
        type="submit"
        variant="contained"
        onClick={handlePasswordReset}
        sx={{ my: 2 }}
      >
        Update password
      </Button>
    </Box>
  );
}

export default ResetPasswordModal;
